module.exports = ".pop-img{bottom: 0}\n.page-content{margin: 50px 0; width: 100%; float: left}\n@media only screen and (max-width: 740px) {\n    .page-content{margin: 30px 0; padding: 15px}\n}\n.img-size{ font-size: 55px;}\n.success-clr{color: #82be37;}\n.fail-clr{color: #ed2327;}\n.info-clr{color: black;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/info/info.component.css
// module id = ./src/app/info/info.component.css
// module chunks = main